export default [
  {
    to: 'borrower',
    label: 'Borrower',
    flagName: 'IncludeBorrower',
  },
  {
    to: 'liabilities',
    label: 'Liabilities',
    flagName: 'IncludeLiability',
  },
  {
    to: 'income',
    label: 'Income',
    flagName: 'IncludeIncome',
  },
  {
    to: 'subject-property',
    label: 'Subject Property',
    flagName: 'IncludeSubjectProperty',
  },
  {
    to: 'assets',
    label: 'Assets',
    flagName: 'IncludeAsset',
  },
  {
    to: 'reo',
    label: 'REO',
    flagName: 'IncludeREO',
  },
];
